module.exports = __webpack_public_path__ + "img/viajes-paso-1.ecfdba1e.png";